import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import pageTransition from "../components/pageTransition";
import { useLocation, useNavigate } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import MetaHelmet from "../components/metaHelmet";

const Partner: React.FC = () => {
    const { t } = useTranslation();

    // Load settings
    const [language] = useState(localStorage.getItem('i18nextLng') || 'en');

    const location = useLocation();
    const internalOrigin = location.state?.fromInternal || false;
    const { trackPageView } = useMatomo();

    const navigate = useNavigate();

    useEffect(() => {
        trackPageView({
            href: window.location.href, // URL der aktuellen Seite
        });
    }, [location]);

    return (
        <ion-page class="sg-body generic">
            <div className="page-container">
                <MetaHelmet
                    title={t('become-partner')}
                />
                <img className="post-image" src={'/images/partner_page.jpeg'} />
                <div className="header-container ion-padding news">
                    {internalOrigin && <button className="arrow-back" style={{ backgroundImage: `url("/icons/back_arrow_white.svg")` }} onClick={() => navigate(-1)}></button>}
                    <h1 className="start-title">
                        {t('become-partner')}
                    </h1>
                </div>

                <div className="generic-page partner">
                    <strong>Basic-Paket – der ideale Einstieg für Betriebe, die online sichtbar sein und von unseren Basisleistungen profitieren möchten.
                    </strong>
                    <br />
                    <ul>
                        <li>
                            <u>Exklusive Sichtbarkeit:</u> Partnerbetriebe werden in einem eigenen, hervorgehobenen Bereich vor anderen Betrieben gelistet.
                        </li>
                        <figure className="wp-block-image size-full"><img loading="lazy" alt="" decoding="async" src="https://graz.smartgastro.at/wp-content/uploads/2025/11/partner_category.jpeg"/></figure>
                        <li>
                            <u>Werbewirksam präsentiert:</u> Ein aussagekräftiges Foto Ihres Betriebs wird bei der Kategorie Beschreibung aufmerksamkeitsstark eingebunden.
                        </li>
                        <figure className="wp-block-image size-full"><img loading="lazy" alt="" decoding="async" src="https://graz.smartgastro.at/wp-content/uploads/2025/11/partner_description.jpeg"/></figure>
                        <li>
                            <u>Farbliche Hervorhebung:</u> In den gewählten Kategorien wird der Betrieb auf unseren interaktiven Karten farblich betont.
                        </li>
                        <figure className="wp-block-image size-full"><img loading="lazy" alt="" decoding="async" src="https://graz.smartgastro.at/wp-content/uploads/2025/11/partner_map.jpeg"/></figure>
                        <li>
                            <u>Eigene Kurzbeschreibung:</u> Jeder Partnerbetrieb erhält eine individuelle Kurzvorstellung in unserer Web-App – direkt sichtbar für alle Nutzer.
                        </li>
                        <li>
                            <u>Veranstaltungen im Rampenlicht:</u> Ihre Live-Events? Veröffentlichen wir gerne und bringen sie gezielt an unser Publikum.
                        </li>
                        <li>
                            <u>Direktlink zu den Social-Media-Kanälen:</u> Wir verlinken Ihr Instagram, Facebook, oder TikTok, damit Sie Ihre Reichweite maximieren können.
                        </li>
                        <li>
                            <u>Social Media Support:</u> Auf Wunsch reposten wir Ihre Beiträge – unkompliziert und schnell.
                        </li>
                        <li>
                            <u>Partnerschaft, die sichtbar wird:</u> Jeder Partnerbetrieb erhält einen exklusiven „Partnerbetrieb“-Aufkleber zur Kennzeichnung vor Ort.
                        </li>
                    </ul>
                    <br />
                    <strong>Premium-Paket – inklusive aller Leistungen des Basic-Pakets plus exklusiven Zusatzfeatures wie:</strong>
                    <br />
                    <ul>
                        <li>
                            <u>Jährliches Spotlight:</u> Ein exklusiver Bericht oder ein Interview auf smartgastro.at setzt Sie als Betrieb in Szene und bleibt auf unserer Webapp integriert.
                        </li>
                        <li>
                            <u>Professionelles Video:</u> Ein jährliches Video – perfekt zur Präsentation Ihres Betriebs und Ihrer Besonderheiten.
                        </li>
                        <li>
                            <u>Doppelte Sichtbarkeit gegenüber dem Basic-Paket:</u> Premium Betriebe erscheinen sowohl in den gewählten Kategorien, als auch bei den Beispielbildern doppelt so oft wie Basic-Partner.
                        </li>
                        <li>
                            <u>Event-Highlight des Jahres:</u> Einmal jährlich wird eines Ihrer Events als „Event der Woche“ besonders hervorgehoben.
                        </li>
                        <li>
                            <u>Gezielte Google-Werbung:</u> Wir bewerben Ihren Betrieb aktiv über Google – für maximale Reichweite.
                        </li>
                        <li>
                            <u>Jobanzeigen mit Sichtbarkeit:</u> Offene Stellen erscheinen in unserem Bereich „Hockn“ – direkt für interessierte User sichtbar.
                        </li>
                        <li>
                            <u>Direkte Reservierung:</u> Verlinkung zu Ihrem Reservierungstool – für schnelle und einfache Buchungen.
                        </li>
                        <li>
                            <u>Premium sichtbar gemacht:</u> Jeder Premium-Partner erhält einen individuell gestalteten, hochwertigen Premium-Partner-Sticker für den Betrieb.
                        </li>
                        <li>
                            <u>Bevorzugter Support:</u> Jede Änderung kann bei uns zum Teilen beantragen werden.
                        </li>
                    </ul>
                    <p>Bei mehreren Partnerbetrieben innerhalb einer Kategorie erfolgt eine gleichmäßige Verteilung. Premium-Partner werden dabei mit einer doppelten Häufigkeit gegenüber Standard-Partnern berücksichtigt.</p>
                    <p>Interessiert? Melde dich gerne unter <a href="mailto:partner@smartgastro.at">partner@smartgastro.at</a> oder auch telefonisch unter <a href="tel:+436764647177">+436764647177</a></p>
                </div>
            </div>
        </ion-page>
    );
}

export default pageTransition(Partner);
